/* @flow */

import React from 'react';
import { Dropdown } from 'semantic-ui-react';

type Props = {
  value: string,
  onChange: (value: string) => void,
};

const TypesOptions = [
  {
    text: 'Date',
    value: 'date',
  },
  {
    text: 'Date et Heure',
    value: 'date-time',
  },
  {
    text: 'Période de Dates',
    value: 'date-range',
  },
  {
    text: 'Période de Dates et Heures',
    value: 'date-time-range',
  },
];

const DateTypeSelector = ({ value, onChange }: Props) => {
  const change = (_, { value }) => onChange(value);

  return (
    <div className="ui field">
      <label>Type de date</label>
      <Dropdown
        name="date.type"
        fluid
        selection
        options={TypesOptions}
        value={value}
        onChange={change}
      />
    </div>
  );
};

export default DateTypeSelector;



// WEBPACK FOOTER //
// ./src/modules/calendar/components/DateTypeSelector.js